import axios from "axios";
import { message } from "antd";

class AxiosClient {
  constructor(baseurl) {
    this.axiosClient = axios.create({
      baseURL: baseurl,
      timeout: 20000,
      headers: {
        contentType: "application/json",
      },
      withCredentials: false,
    });

    this.initializeRequestInterceptor();
    this.initializeResponseInterceptor();
  }

  initializeRequestInterceptor() {
    this.axiosClient.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("accessToken");
        if (token && config.headers)
          config.headers["Authorization"] = `Bearer ${token}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  initializeResponseInterceptor() {
    this.axiosClient.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const { data, status } = error?.response || {};
        const token = localStorage.getItem("accessToken");
        
        // Clear invalid token on 401 or 404
        if (token && (status === 401 || status === 404)) {
          // Only clear if it's an auth-related endpoint
          const url = error?.config?.url || "";
          if (url.includes("/getMe") || url.includes("/get-vip") || 
              (status === 401 && data?.message === "Unauthorized")) {
            console.log("Clearing invalid token from interceptor");
            localStorage.removeItem("accessToken");
            message.destroy();
            // Prevent infinite loops by not triggering queries
            error._handled = true;
          }
        }
        return Promise.reject(error);
      }
    );
  }
}

export default AxiosClient;
